<template>
  <div style="padding: 0 15px" @click="toggleClick">
    <i
      :class="{ 'is-active': isActive }"
      class="el-icon-s-fold"
      width="64"
      height="64"
    ></i>
  </div>
</template>

<script>
export default {
  name: "Hamburger",
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleClick() {
      // 關閉視圖相關操作
      this.lyViewShowChg();
      this.$emit("toggleClick");
    },
  },
};
</script>

<style scoped>
.hamburger {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}

.hamburger.is-active {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue